import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
import CloseSvg from "../../Images/close.svg"
import "./Modal.css";

const Modal = ({ title, children, isOpen, onClose, onConfirm, loading }) => {
    useEffect(() => {
        let modalRoot = document.getElementById('modal-root');
        if (!modalRoot) {
            modalRoot = document.createElement('div');
            modalRoot.id = 'modal-root';
            document.body.appendChild(modalRoot);
        }

        return () => {
            if (modalRoot && modalRoot.childNodes.length === 0) {
                document.body.removeChild(modalRoot);
            }
        };
    }, []);
    if (!isOpen) return null;
    return ReactDOM.createPortal(
        <div className="modal-overlay">
            <div className="modal-container">
                <div className="modal-header">
                    <h3>{title}</h3>
                    <button className="modal-close-btn" onClick={onClose}><img src={CloseSvg} alt="" /></button>
                </div>
                <div className="modal-body">{children}</div>
                <div className="form-modal-footer" style={{marginBottom: "20px"}}>
                    <button className="form-cancel-btn" onClick={onClose}>
                        Cancel
                    </button>
                    <button type="submit" className="form-confirm-btn" disabled={loading} onClick={onConfirm}>
                        {loading ? "Loading..." : "Create"}
                    </button>
                </div>
            </div>
        </div>,
        document.getElementById('modal-root')
    );
};

export default Modal;
